


















































import { Input } from './mixins';
import { ValidationProvider } from 'vee-validate';
import { Component, Prop, Mixins, Emit } from 'vue-property-decorator';

@Component({
  components: {
    ValidationProvider,
  },
})
export default class FormCheckbox extends Mixins(Input) {
  @Prop({ default: true }) onValue!: any;

  @Prop({ default: () => [] }) readonly value!: boolean | number[];

  @Emit('input')
  onChange() {
    return this.localValue;
  }

  get isMultiSelect() {
    if (typeof this.value === 'boolean') {
      return false;
    }

    return true;
  }

  get hasLabelSlot() {
    return !!this.$slots.label;
  }

  get checked() {
    return this.value;
  }

  set checked(val) {
    this.localValue = val;
  }
}
